var map = {
	"./Facebook Messenger.png": "58a2",
	"./Instagram.png": "e1e3",
	"./Union.png": "9467",
	"./Wechat.png": "9b10",
	"./WechatQR.png": "e0df",
	"./WhatsApp.png": "eec7",
	"./WhatsAppQR.png": "676d",
	"./email.png": "9afb",
	"./left-arrows.png": "9308",
	"./logo.png": "cf05",
	"./quick.png": "5cc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";